//charts
import { subscribersGrowthConfig } from '@/lib/analytics/charts/youtube/subscribersGrowthHistory';
import { subscribersEvolutionConfig } from '@/lib/analytics/kpis/youtube/subscribersEvolution';
import { subscribersEvolutionPercentageConfig } from '@/lib/analytics/kpis/youtube/subscribersEvolutionPercentage';
//kpis
import { totalSubscribersConfig } from '@/lib/analytics/kpis/youtube/totalSubscribers';
import { ORIENTATION_HORIZONTAL } from '@/lib/gridElements/orientation';
import { SIZE_33, SIZE_FULL } from '@/lib/gridElements/size';

export const CommunityYoutube = [
    // First line
    { ...totalSubscribersConfig, size: SIZE_33, orientation: ORIENTATION_HORIZONTAL },
    { ...subscribersEvolutionConfig, orientation: ORIENTATION_HORIZONTAL },
    { ...subscribersEvolutionPercentageConfig, orientation: ORIENTATION_HORIZONTAL },

    // Second line
    { ...subscribersGrowthConfig, size: SIZE_FULL }
];

export const requestYoutubeParams = [
    [
        'subscribers',
        'subscribers_evolution',
        'subscribers_evolution_percentage',
        'subscriber_growth'
    ]
];
